/**
 * @file
 * Karhu Helsinki theme javascripts
 */

(function ($, Drupal, drupalSettings) {

  "use strict";

  // Configuration of the observer:
  const observerConf = {
    attributes: true,
    childList: true,
    characterData: true
  };


  const linkSelector = '.sf-accordion li.sf-depth-1';



  Drupal.behaviors.trestonMenu = {
    additionalLinks: [],
    observer: new MutationObserver(function( mutations ) {
      mutations.forEach(Drupal.behaviors.trestonMenu.mutationCallback);
    }),

    mutationCallback: mutation => {
      const { addedNodes } = mutation;

      if( addedNodes !== null ) { // If there are new nodes added

        addedNodes.forEach( node => {

          const menuItems = node.querySelectorAll(linkSelector);

          if (menuItems.length) {

            Drupal.behaviors.trestonMenu.addAdditionalLinksToMobileMenu(menuItems);

            // We dont need observer anymore
            Drupal.behaviors.trestonMenu.observer.disconnect();
          }

        });

      }

    },

    addAdditionalLinksToMobileMenu: items => {

      var lastItem = items[0];
      for (var i = 0; i < items.length; i++) {
        if(items[i].classList.contains('secondary-menu-item') ){
          break;
        }
      }
      i -= 1;

      Drupal.behaviors.trestonMenu.additionalLinks.forEach( additionalNode => {
        var childGuest = document.createElement("li");
        childGuest.classList = additionalNode.classList;
        childGuest.innerHTML = additionalNode.querySelector('a').parentNode.innerHTML
        items[i].parentNode.insertBefore(childGuest, items[i].nextSibling);
      });

    },

    attach: (context, settings) => {

      var dLink = context.querySelector('#block-3dlink')
      var reqOffer = context.querySelector('#block-requestanofferlink')
      var menu = context.querySelector('#block-mainnavigationenglish');

      if (!menu) {
        return;
      }


      if($("#block-mainnavigationenglish .block-_d-header").length < 1) {
        Drupal.behaviors.trestonMenu.additionalLinks.push(reqOffer);
      }

      if($("#block-mainnavigationenglish .block-request-offer-link").length < 1) {
        Drupal.behaviors.trestonMenu.additionalLinks.push(dLink);
      }

      var links = menu.querySelectorAll(linkSelector);
      if (!links.length) {

        Drupal.behaviors.trestonMenu.observer.observe(menu, observerConf);
      }
      else {
        //Drupal.behaviors.trestonMenu.addAdditionalLinksToMobileMenu(links);
      }
    },
  }

})(jQuery, Drupal, drupalSettings);
